import { render, staticRenderFns } from "./RiskTable.vue?vue&type=template&id=1f157b68&scoped=true"
import script from "./RiskTable.vue?vue&type=script&lang=js"
export * from "./RiskTable.vue?vue&type=script&lang=js"
import style0 from "./RiskTable.vue?vue&type=style&index=0&id=1f157b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f157b68",
  null
  
)

export default component.exports